"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const config_1 = require("@root/config");
const resolvedEnvironmentVariables_1 = require("../resolvedEnvironmentVariables");
const { projectCode, stage } = resolvedEnvironmentVariables_1.resolvedEnvironmentVariables;
const TLD = config_1.parentHostedZoneName;
const mailFromSubDomain = 'robots';
const shortProjectCode = projectCode.substring(0, 4);
const getInternalAccountDomain = () => `${stage}.${shortProjectCode}.${TLD}`;
exports.config = {
    google: { gcp: { clientId: '', apiKey: '' } },
    BaseData: {
        Group: {
            groups: [{ name: 'Apex Partners', supportedType: 'Partner' }],
        },
    },
    iotv: {},
    internalAccountDomain: getInternalAccountDomain(),
    mailFromSubDomain: mailFromSubDomain,
    parentAccountDomain: config_1.parentHostedZoneName,
    incidentProducingTypes: ['Gateway', 'Device'],
    apps: {
        webUI: {
            ventureName: shortProjectCode,
            useSpecializedViews: false,
            initialRedirect: null,
            domainMap: undefined,
            supportEmail: undefined,
            pruneGenericEntities: false,
            pruneEntityNetworks: false,
            showProgrammeSets: true,
            groupedObjectTypes: {},
            deviceMap: {},
        },
    },
};
